import { createTheme } from "@mui/material/styles";

const FONT_INTER = '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif';
const FONT_FIGTREE = '"Figtree", "Inter", sans-serif';

export const v2Fonts = {
  inter: FONT_INTER,
};

export const v2Colors = {
  primary: "#5941D5",
  primarySoft: "#F7F3FF",
  progressPurple: "#534AB7",
  progressGreen: "#408D43",
  progressTrack: "#F1EFE8",
  title: "#26215C",
  body: "#7F8195",
  label: "#2A2A2C",
  caption: "#ACACAC",
  link: "#5941D5",
  pageBg: "#F5F7FB",
  tileBg: "#FFFFFF",
  topBorder: "#E8E6E1",
  divider: "#E9E9E9",
  navActiveBg: "#E5E7E9",
  navActiveText: "#2D2F31",
  navIdle: "#7C7F7E",
  navIcon: "#8D9199",
  navSection: "#717680",
};

export const v2Theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 800,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: v2Colors.primary,
      light: v2Colors.primarySoft,
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#7C5CFC",
    },
    success: {
      main: v2Colors.progressGreen,
    },
    info: {
      main: "#3B82F6",
    },
    error: {
      main: "#AD3030",
    },
    text: {
      primary: v2Colors.label,
      secondary: v2Colors.body,
    },
    background: {
      default: v2Colors.pageBg,
      paper: "#FFFFFF",
    },
    divider: v2Colors.divider,
  },
  typography: {
    fontFamily: FONT_INTER,
    h1: {
      fontFamily: FONT_FIGTREE,
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: 1,
      color: v2Colors.title,
    },
    h2: {
      fontFamily: FONT_FIGTREE,
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: 1,
      color: v2Colors.title,
    },
    body1: {
      fontFamily: FONT_INTER,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: FONT_INTER,
      fontSize: "13px",
      fontWeight: 400,
      lineHeight: 1.4,
    },
    button: {
      fontFamily: FONT_FIGTREE,
      fontWeight: 500,
      fontSize: "14px",
      textTransform: "none",
    },
    caption: {
      fontFamily: FONT_FIGTREE,
      fontSize: "13px",
      fontWeight: 500,
      letterSpacing: 0,
      textTransform: "uppercase",
      color: v2Colors.caption,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "#edsimsV2-root": {
          fontFamily: FONT_INTER,
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
        "#edsimsV2-root a": {
          textDecoration: "none",
        },
        "#edsimsV2-root *": {
          boxSizing: "border-box",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          backgroundImage: "none",
          boxShadow: "none",
          border: "none",
          borderRadius: 24,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: FONT_FIGTREE,
          fontWeight: 500,
          fontSize: "14px",
          borderRadius: 100,
          boxShadow: "none",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});
